import { Close } from '@mui/icons-material'
import { Box, IconButton, LinearProgress, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'
import TenantLogo from '../../tenant-logo'

const PageHeader = ({
  title,
  subtitle,
  questionNumber,
  totalQuestions,
  onClose,
  onCloseWithSavePartial,
  onSkip,
  showSkipButton = false,
  showCloseButton = true,
  tenant,
  showLogo = false,
  hideProgress = false
}) => {
  const classes = useStyles()

  const shouldShowSkip = showSkipButton
  const shouldShowClose = showCloseButton
  const progressValue = totalQuestions > 0 ? (questionNumber / totalQuestions) * 100 : 0

  return (
    <>
      {shouldShowSkip && (
        <Typography
          component='button'
          className={classes.skipButton}
          onClick={() => onSkip('skip-button')}
          tabIndex={0}
          role='button'
          aria-label='Skip questionnaire for now'
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onSkip('skip-button')
            }
          }}
          data-test='page-header-skip-button'
        >
          Skip for now
        </Typography>
      )}

      <Box className={classes.header}>
        {showLogo && tenant
          ? (
            <TenantLogo
              tenant={tenant}
              height={40}
              className={classes.tenantLogo}
            />
            )
          : (
            <Typography className={classes.title}>
              {title}
            </Typography>
            )}
        {shouldShowClose && (
          <IconButton
            className={classes.closeButton}
            onClick={() => onCloseWithSavePartial ? onCloseWithSavePartial('close-button') : onClose('close-button')}
            data-test='page-header-close-button'
            aria-label='Close questionnaire'
          >
            <Close />
          </IconButton>
        )}
      </Box>

      {!hideProgress && (
        <LinearProgress
          variant='determinate'
          value={progressValue}
          className={classes.progressBar}
          data-test='page-header-progress-bar'
          aria-label={`Personalization progress: question ${questionNumber} of ${totalQuestions}`}
        />
      )}
    </>
  )
}

export default PageHeader
